import { render } from "./RepresentativeAccounts.vue?vue&type=template&id=556e3d2b&ts=true"
import script from "./RepresentativeAccounts.vue?vue&type=script&lang=ts"
export * from "./RepresentativeAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__